/**
 * Created by Jerker Nord on 2018-07-05.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolName} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolName";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/core/utils/ArrayHelper";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {IceIceYetiWildInIceReelAttentionView} from "./IceIceYetiWildInIceReelAttentionView";

export class IceIceYetiWildInIceReelAttentionController extends ReelStopPresentationController {

    private _view:IceIceYetiWildInIceReelAttentionView;
    private _nearWinReels:boolean[];
    private _activeGameAreaAfterRandomTrigger:boolean[][];
    private _isPlaying:boolean = false;

    constructor(index:number) {
        super(index, "IceIceYetiWildInIceReelAttentionController");
        this._view = new IceIceYetiWildInIceReelAttentionView();
    }

    protected parseFeatureGameData(data:IceIceYetiParsedGameData):void {
        this._nearWinReels = data.nearWinReels != null ? data.nearWinReels : ArrayHelper.initArrayWithValues<boolean>(GameConfig.instance.REELS_NUM, (index:number) => {return false});
        this._activeGameAreaAfterRandomTrigger = data.activeGameAreaAfterRandomTrigger;
    }

    public onReelBounce(data:IReelStoppedData):void {
        if(data.quickStop) {
            if(this._isPlaying) {
                this._view.abort();
            }
        } else {
            //Check if next reel is near win
            if(this._nearWinReels[data.reelId + 1]) {
                this._view.playRealAttention(data.reelId + 1);
                // Move the attention reel on top.
                const nextView = (<SpinReelController>Reels.getReel(data.reelId + 1)).view;
                nextView.parent.addChild(nextView);
                EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {reelSetName : "NEAR_WIN_REELSET"}));
                EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.ADD_SLOW_ATTENTION_SPIN_SYMBOL_TO_REEL, {
                    reelId : data.reelId + 1,
                    symName : ReelSymbolName.WILD,
                    spinSpeed : 0.6,
                    startPosition : this.getSlowAttentionStartPosition(data.reelId + 1),
                    steps : this.getSlowAttentionStartSteps(data.reelId + 1),
                    symbolState : IceIceYetiGameConfig.instance.SYMBOL_STATES.spinNearWin
                }));
                this._isPlaying = true;
            } else if(this._isPlaying) {
                this._view.reset();
            }
        }

        EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REMOVE_SLOW_ATTENTION_SPIN_SYMBOL_FROM_REEL, data.reelId, ReelSymbolName.WILD));

        this.dispatchCompleteEvent(data.reelId);
    }

    private getSlowAttentionStartPosition(reelId:number):number {
        return this._activeGameAreaAfterRandomTrigger && this._activeGameAreaAfterRandomTrigger[reelId][1] ? -1 : 0;
    }

    private getSlowAttentionStartSteps(reelId:number):number {
        let steps:number = 3;
        if(this._activeGameAreaAfterRandomTrigger) {
            if(this._activeGameAreaAfterRandomTrigger[reelId][1]) {
                steps++;
            }
            if(this._activeGameAreaAfterRandomTrigger[reelId][5]) {
                steps++;
            }
        }

        return steps;
    }
}